module.exports = "/_next/static/images/cg-f2e458f5f49ae9ba87a13d90155b4bf8.svg";